export enum OrganizationTitleTypeEnum {
  Styrelse = 0,
  Förtroendevalda = 2,
}
